<div class="paginator">
    <div
        data-cy="paginator-left-arrow"
        class="paginator-button arrow"
        [ngClass]="{
            'hover-cursor-select': currentPage != 1,
            disabled: currentPage === 1
        }"
        (click)="selectPage(currentPage - 1)"
    >
        &larr;
    </div>

    <div
        data-cy="paginator-first-page"
        *ngIf="shouldPrependFirstPage()"
        class="paginator-button"
        (click)="selectPage(1)"
        [ngClass]="{ highlighted: currentPage === 1 }"
    >
        1
    </div>

    <div
        data-cy="paginator-left-dots"
        *ngIf="shouldPrependFirstPage()"
        (click)="selectPage(currentPage - 2)"
        class="paginator-button"
    >
        . . .
    </div>

    <div
        data-cy="paginator-page"
        *ngFor="let pageNumber of pagesToShow"
        class="paginator-button"
        [ngClass]="{ highlighted: pageNumber === currentPage }"
        (click)="selectPage(pageNumber)"
    >
        {{ pageNumber }}
    </div>

    <div
        data-cy="paginator-right-dots"
        *ngIf="shouldAppendLastPage()"
        (click)="selectPage(currentPage + 2)"
        class="paginator-button"
    >
        . . .
    </div>

    <div
        data-cy="paginator-last-page"
        *ngIf="shouldAppendLastPage()"
        class="paginator-button"
        (click)="selectPage(pages)"
        [ngClass]="{ highlighted: currentPage === pages }"
    >
        {{ pages }}
    </div>

    <div
        data-cy="paginator-right-arrow"
        class="paginator-button arrow"
        [ngClass]="{
            'hover-cursor-select': currentPage != pages,
            disabled: currentPage == pages
        }"
        (click)="selectPage(currentPage + 1)"
    >
        &rarr;
    </div>
</div>
